var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-tabs',{staticClass:"custom"},[_c('van-tab',{attrs:{"title":"活动详情"}},[_c('div',{staticClass:"global--rich",domProps:{"innerHTML":_vm._s(_vm.rich)}})]),_c('van-tab',{attrs:{"title":"直播动态"}},[_c('more-dynamic',{attrs:{"list":_vm.lives}})],1),_c('van-tab',{attrs:{"title":"相册"}},[_c('more-photo',{attrs:{"list":_vm.album}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }